import { FORM_PATHS, openInModalOrPage } from '../../modals';

export const editAddress = (address, companyId) => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.EditAddress, address.addressId, address, companyId));
};
